import type { ReactNode } from 'react';

export const symbol_docs: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h274q12.29 0 23.42 4.43Q568.55-871.13 577-863l165 164q8 8 13 19.28 5 11.28 5 23.72v516q0 24-18 42t-42 18H260Zm190-740H260v680h440v-433H563q-47.08 0-80.04-32.96Q450-638.92 450-686v-134Zm60 0v134q0 22.53 15.24 37.76Q540.47-633 563-633h137v-23L534-820h-24ZM380-228q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h117q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H380Zm0-140q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h200q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H380Z"
		/>
	</svg>
);
